export class Point
{
    X: number;
    Y: number;

    constructor( x: number, y: number )
    {
        this.X = x;
        this.Y = y;
    }
}